import React from 'react';
import {
  AlertTriangle,
  CheckCircle2,
  Loader2,
  XCircle,
} from 'lucide-react';
import { Badge } from '@easyflow/ui-frontend/components/ui/badge';

export const ROUTINE_SOURCE_LABELS: Record<string, string> = {
  manual: 'Avvio manuale',
  schedule: 'Pianificata',
  event: 'Da evento',
};

export function formatRoutineDateTime(value: string | null): string {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString('it-IT', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function RoutineStatusBadge({ status }: { status: string }): React.ReactElement {
  if (status === 'completed') {
    return <Badge className="border-0 bg-success/15 text-success"><CheckCircle2 className="mr-1 h-3 w-3" />Completata</Badge>;
  }
  if (status === 'failed') {
    return <Badge className="border-0 bg-danger/15 text-danger"><XCircle className="mr-1 h-3 w-3" />Fallita</Badge>;
  }
  if (status === 'cancelled') {
    return <Badge className="border-0 bg-muted text-muted-foreground"><XCircle className="mr-1 h-3 w-3" />Annullata</Badge>;
  }
  if (status === 'awaiting_confirmation') {
    return <Badge className="border-0 bg-warning/15 text-warning"><AlertTriangle className="mr-1 h-3 w-3" />Da confermare</Badge>;
  }
  return <Badge className="border-0 bg-ai/15 text-ai"><Loader2 className="mr-1 h-3 w-3 animate-spin" />In esecuzione</Badge>;
}